import { render, staticRenderFns } from "./LanguageItem.vue?vue&type=template&id=f7b08262&scoped=true"
import script from "./LanguageItem.vue?vue&type=script&lang=js"
export * from "./LanguageItem.vue?vue&type=script&lang=js"
import style0 from "./LanguageItem.vue?vue&type=style&index=0&id=f7b08262&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b08262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7b08262')) {
      api.createRecord('f7b08262', component.options)
    } else {
      api.reload('f7b08262', component.options)
    }
    module.hot.accept("./LanguageItem.vue?vue&type=template&id=f7b08262&scoped=true", function () {
      api.rerender('f7b08262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/LanguageItem.vue"
export default component.exports